import React, { useState, useEffect, useRef } from "react";
import "./Membership.css"; 
import { Link } from "react-router-dom";

function Membership() {
  const [inView, setInView] = useState(false);
  const membershipSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (membershipSectionRef.current) {
        const rect = membershipSectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
          setTimeout(() => {
            if (membershipSectionRef.current) {
              membershipSectionRef.current.classList.add("done");
            }
          }, 2000);
        } else {
          setInView(false);
          if (membershipSectionRef.current) {
            membershipSectionRef.current.classList.remove("done");
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <section className={`membership-section animate-up ${inView ? "in-view" : ""}`}
    ref={membershipSectionRef} >
      <div>
        <h3 className="section-header">Membership in the ASG means:</h3>
        <div className="row">
          <div className="col membership">
            <img
              src="/images/network.svg"
              width="80px"
              alt="network icon"
              className="icon transition"
            />
            <h3>Networking Opportunities</h3>
            <p>
              Meetings, programs and social events are included or offered at
              special member pricing
            </p>
          </div>
          <div className="col membership">
            <img
              src="/images/employee.svg"
              width="80px"
              alt="employee icon"
              className="icon transition"
            />
            <h3>Professional Development</h3>
            <p>
              Frequent programs feature great speakers at seminars, webinars,
              and workshops
            </p>
          </div>
          <div className="col membership">
            <img
              src="/images/team.svg"
              width="80px"
              alt="team icon"
              className="icon transition"
            />
            <h3>Communities & Recognition</h3>
            <p>
            Active practice areas, committees 
            and working groups both locally and international available
            </p>
          </div>
          <div className="col membership">
            <img
              src="/images/information.svg"
              width="80px"
              alt="information icon"
              className="icon transition"
            />
            <h3>Information & Resources</h3>
            <p>
            Research papers, articles, 
            conference papers, industry updates, newsletters and ASG impact stories
            </p>
          </div>
        </div>
        <p className="join-us">
          <b className="join-as" >Join as</b>
          <span>
            <bottom className="careox-btn"><Link to="#">Member</Link></bottom>
          </span>
          <span>
            <bottom className="careox-btn"><Link to="#">Volunteer</Link></bottom>
          </span>
          <span>
            <bottom className="careox-btn"><Link to="#">Partner</Link></bottom>
          </span>
        </p>
      </div>
    </section>
  );
}

export default Membership;
